//汇总reducer
import { combineReducers } from 'redux'
import traj from './traj'

export default combineReducers({
    traj
})